/**
 * The five steps of an import, and where it has got to.
 *
 * The state labels come from a WHITELIST, not from the raw string. A
 * runtime-built key like t(`assistant.build.state.${state}`) renders the key
 * itself at the user for any value nobody wrote a string for, and the i18n test
 * only proves the PREFIX resolves — never the leaf. `WorkspaceContextPanel`
 * solves the same problem the same way.
 */
import React from 'react';
import { useI18n } from '../../../i18n';
import { STEPS } from '../utils/datasetPlanRunner';

const STEP_LABEL_KEYS = {
  cluster: 'assistant.build.step.cluster',
  project: 'assistant.build.step.project',
  model: 'assistant.build.step.model',
  upload: 'assistant.build.step.upload',
  verify: 'assistant.build.step.verify',
};

const STATE_LABEL_KEYS = {
  pending: 'assistant.build.state.pending',
  running: 'assistant.build.state.running',
  done: 'assistant.build.state.done',
  skipped: 'assistant.build.state.skipped',
  failed: 'assistant.build.state.failed',
};

const STATE_ICONS = {
  pending: 'fa-circle-notch',
  running: 'fa-circle-notch fa-spin',
  done: 'fa-check-circle',
  skipped: 'fa-minus-circle',
  failed: 'fa-exclamation-triangle',
};

/** Map any value to a state we have a string for. */
const normaliseState = (value) =>
  Object.prototype.hasOwnProperty.call(STATE_LABEL_KEYS, value) ? value : 'pending';

const BuildStepList = ({ steps, percent, current }) => {
  const { t } = useI18n();

  return (
    <ol className="lf-steps">
      {STEPS.map((id) => {
        const state = normaliseState((steps || {})[id]);
        const isCurrent = current === id && state === 'running';
        return (
          <li key={id} className={`lf-steps__row lf-steps__row--${state}`}>
            <i className={`fa ${STATE_ICONS[state]} lf-steps__icon`} aria-hidden="true" />
            <span className="lf-steps__label">{t(STEP_LABEL_KEYS[id])}</span>
            <span className="lf-steps__state">{t(STATE_LABEL_KEYS[state])}</span>
            {isCurrent && percent > 0 && (
              <span className="lf-steps__bar" aria-hidden="true">
                <span className="lf-steps__fill" style={{ width: `${Math.min(100, percent)}%` }} />
              </span>
            )}
          </li>
        );
      })}
    </ol>
  );
};

export default BuildStepList;
